import { render, staticRenderFns } from "./ChangeGroup.vue?vue&type=template&id=3b4723ca&scoped=true"
import script from "./ChangeGroup.vue?vue&type=script&lang=js"
export * from "./ChangeGroup.vue?vue&type=script&lang=js"
import style0 from "./ChangeGroup.vue?vue&type=style&index=0&id=3b4723ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4723ca",
  null
  
)

export default component.exports